import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AuditLogsComponent} from './audit-logs.component';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatTooltipModule} from '@angular/material/tooltip';
import {AuditLogsTableComponent} from './audit-logs-table/audit-logs-table.component';
import {MatTableModule} from '@angular/material/table';
import {AuditLogsSearchComponent} from './audit-logs-search/audit-logs-search.component';
import {MatPaginatorModule} from '@angular/material/paginator';
import {ReactiveFormsModule} from '@angular/forms';
import {MaterialModule} from '../material.module';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material/core';
import {AuditLogComponent} from './audit-log/audit-log.component';
import {EffectsModule} from '@ngrx/effects';
import {AuditLogsEffects} from './audit-logs.effects';
import {StoreModule} from '@ngrx/store';
import {auditLogsFeatureKey, auditLogsReducer} from './audit-logs.state';

@NgModule({
  declarations: [
    AuditLogsComponent,
    AuditLogsTableComponent,
    AuditLogsSearchComponent,
    AuditLogComponent
  ],
  exports: [
    AuditLogComponent
  ],
  imports: [
    CommonModule,
    MatButtonToggleModule,
    MatTooltipModule,
    MatTableModule,
    MatPaginatorModule,
    ReactiveFormsModule,
    MaterialModule,
    MatDatepickerModule,
    MatNativeDateModule,
    StoreModule.forFeature(auditLogsFeatureKey, auditLogsReducer),
    EffectsModule.forFeature([AuditLogsEffects])
  ]
})
export class AuditLogsModule {
}
